import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.sort";
import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.to-string";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import pick from 'lodash.pick';
import { queryFactorList as _queryFactorList, queryStandardList as _queryStandardList } from '@/api/api';
import { deleteAction, getAction, httpAction } from '@/api/manage';
import moment from 'moment';
var columns1 = [{
  title: '因子ID',
  dataIndex: 'factorId',
  align: 'center',
  width: '15%',
  scopedSlots: {
    customRender: 'factorId'
  }
}, {
  title: '限制类型',
  dataIndex: 'restriction',
  align: 'center',
  width: '15%',
  scopedSlots: {
    customRender: 'restriction'
  }
}, {
  title: '最小值',
  dataIndex: 'lower',
  width: '15%',
  align: 'center',
  scopedSlots: {
    customRender: 'lower'
  }
}, {
  title: '最大值',
  align: 'center',
  dataIndex: 'upper',
  width: '15%',
  scopedSlots: {
    customRender: 'upper'
  }
}, {
  title: '序号',
  dataIndex: 'sort',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'sort'
  }
}, {
  title: '操作',
  align: 'center',
  width: '15%',
  dataIndex: 'operation',
  scopedSlots: {
    customRender: 'operation'
  }
}];
var data1 = []; // PS相关的KEY不能为title关键字

var addDataIndex = 0;
export default {
  name: 'RiverList',
  mixins: [JeecgListMixin],
  components: {},
  data: function data() {
    this.cacheData = data1.map(function (item) {
      return _objectSpread({}, item);
    });
    return {
      // 复制相关start
      selectedRowKeys: [],
      copyData: [],
      copyState: false,
      copyId: 0,
      selectCopylist: [],
      // 复制相关end
      data1: data1,
      columns1: columns1,
      addDataIndex: addDataIndex,
      stList: [],
      factorOptions: [],
      StandardOptions: [],
      seen: true,
      upper_status: true,
      lower_status: true,
      iExpandedKeys: [],
      loading: false,
      autoExpandParent: true,
      currFlowId: '',
      currFlowName: '',
      disable: true,
      treeData: [],
      visible: false,
      standardTree: [],
      rightClickSelectedKey: '',
      hiding: true,
      model: {},
      dropTrigger: '',
      river: {},
      searchValue: '',
      disableSubmit: false,
      checkedKeys: [],
      selectedKeys: [],
      autoIncr: 1,
      currSelected: {},
      nodeSelected: {},
      formTitle: '添加环境标准',
      form: this.$form.createForm(this),
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      graphDatasource: {
        nodes: [],
        edges: []
      },
      validatorRules: {
        standardId: {
          rules: [{
            required: true,
            message: '请选择环境标准！'
          }]
        },
        category: {
          rules: [{
            required: true,
            message: '请选择类型！'
          }]
        },
        grade: {
          rules: [{
            required: true,
            message: '请输入级别！'
          }]
        },
        color: {
          rules: [{
            required: true,
            message: '请选择颜色！'
          }]
        },
        title: {
          rules: [{
            required: true,
            message: ''
          }]
        },
        alias: {
          rules: [{
            required: true,
            message: ''
          }]
        },
        status: {
          rules: [{
            required: true,
            message: ''
          }]
        }
      },
      url: {
        add: '/site/standard',
        stList: '/site/sys/type/find',
        deleteBatch: '/site/standard/deleteBatch',
        exportXlsUrl: '/site/standard/exportXls',
        importExcelUrl: '/site/standard/importExcel'
      }
    };
  },
  computed: {
    importExcelUrl: function importExcelUrl() {
      return "".concat(window._CONFIG['domianURL'], "/").concat(this.url.importExcelUrl);
    }
  },
  methods: {
    loadData: function loadData() {
      this.refresh();
      this.queryStandardList();
      this.queryFactorList();
    },
    // 加载环境标准指标
    loadStandardItem: function loadStandardItem() {
      var that = this;
      var params = {
        pageNo: 1,
        pageSize: 10000,
        standardOptionId: this.model.id,
        column: 'sort',
        order: 'asc'
      };
      getAction('/site/standard/item', params).then(function (res) {
        if (res.success) {
          var paramList = [];

          for (var i = 0; i < res.result.records.length; i++) {
            var param = res.result.records[i];
            param.key = param.id;
            param.editable = true; // 判断限制类型决定是否显示最大值、最小值

            if (param.restriction == 2 || param.restriction == 4) {
              param.upper_status = false;
              param.lower_status = true;
            } else if (param.restriction == 3 || param.restriction == 5) {
              param.upper_status = true;
              param.lower_status = false;
            } else if (param.restriction == 1) {
              param.upper_status = true;
              param.lower_status = true;
            } else if (param.restriction == '') {
              param.upper_status = false;
              param.lower_status = false;
            }

            paramList.push(param);
          }

          that.data1 = paramList;
        }
      });
    },
    onChange: function onChange(e) {
      this.searchValue = e.target.value;
    },
    loadTree: function loadTree() {
      var _this = this;

      var that = this;
      that.treeData = [];
      that.standardTree = [];
      getAction('/site/standard/queryTreeList').then(function (res) {
        console.log(res);

        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            temp.value = temp.value.toString().substring(3);
            that.treeData.push(temp);
            that.standardTree.push(temp);
            console.log('temp:' + temp);
            console.log('treeData:' + that.treeData);
            that.setThisExpandedKeys(temp);
          }

          _this.loading = false;
        }
      });
    },
    setThisExpandedKeys: function setThisExpandedKeys(node) {
      if (node.children && node.children.length > 0) {
        this.iExpandedKeys.push(node.key);

        for (var a = 0; a < node.children.length; a++) {
          this.setThisExpandedKeys(node.children[a]);
        }
      }
    },
    refresh: function refresh() {
      this.loading = true;
      this.loadTree();
    },
    // 右键操作方法
    rightHandle: function rightHandle(node) {
      this.dropTrigger = 'contextmenu';
      this.rightClickSelectedKey = node.node.eventKey;
    },
    onExpand: function onExpand(expandedKeys) {
      console.log('onExpand', expandedKeys); // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.

      this.iExpandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    backFlowList: function backFlowList() {
      this.$router.back(-1);
    },
    // 右键点击下拉框改变事件
    dropStatus: function dropStatus(visible) {
      if (visible == false) {
        this.dropTrigger = '';
      }
    },
    // 右键下拉关闭下拉框
    closeDrop: function closeDrop() {
      this.dropTrigger = '';
    },
    addRootNode: function addRootNode() {
      this.$refs.nodeModal.add(this.currFlowId, '');
    },
    batchDel: function batchDel() {
      if (this.checkedKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
      } else {
        var ids = '';

        for (var a = 0; a < this.checkedKeys.length; a++) {
          ids += this.checkedKeys[a] + ',';
        }

        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '确定要删除所选中的 ' + this.checkedKeys.length + ' 条数据（包括环境标准条目）?',
          onOk: function onOk() {
            deleteAction(that.url.deleteBatch, {
              ids: ids
            }).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.loadTree();
                that.onClearSelected();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    },
    nodeModalOk: function nodeModalOk() {
      this.loadTree();
    },
    nodeModalClose: function nodeModalClose() {},
    hide: function hide() {
      this.visible = false;
    },
    onCheck: function onCheck(checkedKeys, info) {
      this.hiding = false;
      this.checkedKeys = checkedKeys.checked;
    },
    onSelect: function onSelect(selectedKeys, e) {
      this.hiding = false;
      var record = e.node.dataRef;
      var recordToForm = e.node.dataRef.data;
      console.log('onSelect-record', record);
      this.nodeSelected = Object.assign({}, record);
      this.currSelected = Object.assign({}, recordToForm);
      this.model = this.currSelected;
      this.selectedKeys = [record.key]; // 选中的key

      this.model.standardId = recordToForm.standardId;
      this.recordToForm = recordToForm;
      this.setValuesToForm(recordToForm, this.selectedKeys);
    },
    // 触发onSelect事件时,为部门树右侧的form表单赋值
    setValuesToForm: function setValuesToForm(record, selectedKeys) {
      var _this2 = this;

      console.log('record', record, selectedKeys);
      this.seen = selectedKeys.toString().substring(0, 3) === 'K2_'; // 判断当前选中是父节点还是子节点

      if (this.seen) this.formTitle = '修改环境标准条目'; // 修改标题
      else this.formTitle = '修改环境标准';
      this.data1 = [];
      this.addDataIndex = 1;
      this.selectedRowKeys = []; // this.queryFactorList();
      // this.queryStandardList();

      if (typeof record.id != 'undefined') {
        this.loadStandardItem(); // 加载环境标准指标
      }

      this.loadStList();
      this.model = Object.assign({}, record);
      this.form = this.$form.createForm(this);
      this.$nextTick(function () {
        _this2.form.setFieldsValue(pick(_this2.model, 'code', 'title', 'color', 'alias', 'category', 'st', 'issueDate', 'issueDept', 'implDate', 'oldStd', 'status', 'sort', 'remark', 'standardId', 'grade')); //时间格式化


        _this2.form.setFieldsValue({
          issueDate: _this2.model.issueDate ? moment(_this2.model.issueDate) : null
        });

        _this2.form.setFieldsValue({
          implDate: _this2.model.implDate ? moment(_this2.model.implDate) : null
        });
      });
    },
    getCurrSelectedTitle: function getCurrSelectedTitle() {
      return !this.currSelected.title ? '' : this.currSelected.title;
    },
    onClearSelected: function onClearSelected() {
      this.hiding = true;
      this.checkedKeys = {};
      this.currSelected = {};
      this.nodeSelected = {};
      this.form.resetFields();
      this.selectedKeys = [];
      this.data1 = [];
    },
    handleNodeTypeChange: function handleNodeTypeChange(val) {
      this.currSelected.nodeType = val;
    },
    notifyTriggerTypeChange: function notifyTriggerTypeChange(value) {
      this.currSelected.notifyTriggerType = value;
    },
    receiptTriggerTypeChange: function receiptTriggerTypeChange(value) {
      this.currSelected.receiptTriggerType = value;
    },
    submitCurrForm: function submitCurrForm() {
      var _this3 = this;

      this.form.validateFields(function (err, values) {
        if (!err) {
          var formData = Object.assign(_this3.model, values); //时间格式化

          formData.standard = values;
          formData.standardList = values; //debugger

          console.log(_this3.model.id);
          console.log('formData', formData);
          formData.standard.id = _this3.model.id;
          formData.standardList.id = _this3.model.id;

          if (!_this3.seen) {
            formData.standard.issueDate = formData.issueDate ? formData.issueDate.format('YYYY-MM-DD HH:mm:ss') : null;
            formData.standard.implDate = formData.implDate ? formData.implDate.format('YYYY-MM-DD HH:mm:ss') : null;
          }

          formData.standardItemList = _this3.data1;
          formData.key = _this3.selectedKeys.toString().substring(0, 3);
          console.log('Received values of form: ', formData);
          httpAction(_this3.url.add, formData, 'post').then(function (res) {
            if (res.success) {
              var keys = JSON.parse(JSON.stringify(_this3.selectedKeys));
              var recordToForm = JSON.parse(JSON.stringify(_this3.recordToForm));

              _this3.$notification.success({
                message: '保存成功!'
              });

              _this3.loadTree(); // this.onClearSelected()


              _this3.setValuesToForm(formData, keys);
            } else {
              _this3.$message.error(res.message);
            }
          });
        }
      });
    },
    emptyCurrForm: function emptyCurrForm() {
      this.form.resetFields();
    },
    loadStList: function loadStList() {
      var _this4 = this;

      getAction(this.url.stList).then(function (res) {
        if (res.success) {
          _this4.stList = res.result;
        }
      });
    },
    nodeSettingFormSubmit: function nodeSettingFormSubmit() {
      this.form.validateFields(function (err, values) {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },
    openSelect: function openSelect() {
      this.$refs.siteDirectiveModal.show();
    },
    handleAdd: function handleAdd(num) {
      var _this5 = this;

      this.model.id = null;
      this.upper_status = false;
      this.lower_status = false;

      if (num == 1) {
        var key = this.nodeSelected.key;
        console.log(key);
        this.seen = false;
        this.formTitle = '添加环境标准';
        this.emptyCurrForm();
        this.onClearSelected();
        this.loadStList();
        this.data1 = [];
        this.selectedKeys = ['K1_'];
        this.$nextTick(function () {
          _this5.form.setFieldsValue({
            category: key.substring(3)
          });
        });
      } else {
        var _key = this.nodeSelected.key;

        if (!_key) {
          this.$message.warning('请先选中环境标准!');
          return false;
        }

        this.seen = true;
        this.currSelected.id = null;
        this.data1 = [];
        this.formTitle = '添加环境标准条目';
        this.emptyCurrForm();
        this.queryStandardList();
        this.$nextTick(function () {
          _this5.form.setFieldsValue({
            standardId: parseInt(_key.substring(3))
          });
        });
        this.selectedKeys = ['K2_'];
      }
    },
    handleDelete: function handleDelete() {
      var that = this;
      deleteAction(that.url.deleteBatch, {
        ids: that.rightClickSelectedKey
      }).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loadTree();
          that.onClearSelected();
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },
    selectDirectiveOk: function selectDirectiveOk(record) {
      console.log('选中指令数据', record);
      this.nodeSettingForm.setFieldsValue({
        directiveCode: record.directiveCode
      });
      this.currSelected.siteCode = record.siteCode;
    },
    getFlowGraphData: function getFlowGraphData(node) {
      this.graphDatasource.nodes.push({
        id: node.id,
        text: node.flowNodeName
      });

      if (node.children.length > 0) {
        for (var a = 0; a < node.children.length; a++) {
          var temp = node.children[a];
          this.graphDatasource.edges.push({
            source: node.id,
            target: temp.id
          });
          this.getFlowGraphData(temp);
        }
      }
    },
    // 获取所有环境标准
    queryStandardList: function queryStandardList() {
      var that = this;
      var params = {
        pageNo: 1,
        pageSize: 10000
      };

      _queryStandardList(params).then(function (res) {
        if (res.success) {
          that.StandardOptions = res.result.records;
        }
      });
    },
    // 获取所有监测因子
    queryFactorList: function queryFactorList() {
      var that = this;
      var params = {
        pageNo: 1,
        pageSize: 10000,
        status: 1
      };

      _queryFactorList(params).then(function (res) {
        if (res.success) {
          that.factorOptions = res.result.records;
          console.log(that.factorOptions);
        }
      });
    },

    /**
     * 获取选中值
     * @param value
     */
    handleChangeStandard: function handleChangeStandard(value) {
      console.log("selected ".concat(value));
      this.factorId = value;
      console.log(this.form);
    },

    /**
     * 获取选中值
     * @param value
     */
    handleChange: function handleChange(value) {
      console.log("selected ".concat(value));
      this.columns1.factorId = value;
      console.log(this.form);
    },

    /**
     * 监测因子过滤
     * @param input
     * @param option
     * @returns {boolean}
     */
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    // 监测因子表格相关的操作函数
    handleChangeTable: function handleChangeTable(value, key, column) {
      var newData = _toConsumableArray(this.data1);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        target[column] = value;
        this.data1 = newData;
      }
    },
    handleChangeRestriction: function handleChangeRestriction(value, key, column) {
      var newData = _toConsumableArray(this.data1);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0]; // const target1 = newData.filter(item => key != item.key)[0]

      if (target) {
        target[column] = value; //判断限制类型决定是否显示最大值、最小值

        if (value == 2 || value == 4) {
          target['upper_status'] = false;
          target['lower_status'] = true;
          target.lower = ' ';
        } else if (value == 3 || value == 5) {
          target['upper_status'] = true;
          target['lower_status'] = false;
          target.upper = ' ';
        } else if (value == 1) {
          target['upper_status'] = true;
          target['lower_status'] = true;
        } else if (value == '') {
          target['upper_status'] = false;
          target['lower_status'] = false;
        }

        this.data1 = newData;
      }
    },
    addTable: function addTable() {
      var newData = _toConsumableArray(this.data1);

      console.log(_toConsumableArray(this.data1));
      newData.push({
        key: 'A1_' + this.addDataIndex,
        factorId: '',
        restriction: '',
        lower: '',
        upper: '',
        sort: '',
        editable: true
      });
      console.log(newData);
      this.addDataIndex = this.addDataIndex + 1;
      this.data1 = newData;
      this.cacheData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },
    onSelectChange: function onSelectChange(val) {
      console.log(val);
      this.selectedRowKeys = val;
      var arr = [];

      if (val.length > 0) {
        this.data1.forEach(function (item, index) {
          val.forEach(function (item1, index1) {
            if (item.key == item1) {
              arr.push(item);
            }
          });
        });
      }

      this.selectCopylist = arr;
    },
    // 复制
    copy: function copy() {
      if (this.selectedRowKeys.length > 0) {
        this.copyState = true;
        this.copyData = this.selectCopylist;
        this.$message.success('复制成功');
        this.copyId = this.model.id;
      } else {
        this.$message.warn('请选择至少一项进行复制');
      }
    },
    // 粘贴
    snippets: function snippets() {
      var _this6 = this;

      var arr = [];

      if (this.data1.length > 0) {
        this.selectCopylist.forEach(function (item, index) {
          var state = true;

          _this6.data1.forEach(function (item1, index1) {
            if (item.factorId == item1.factorId) {
              state = false;
            }
          });

          if (state) {
            var obj = {
              key: 'A1_' + _this6.addDataIndex,
              factorId: item.factorId,
              restriction: item.restriction,
              lower: item.lower,
              upper: item.upper,
              sort: item.sort,
              editable: true
            };

            if (item.restriction == 2 || item.restriction == 4) {
              obj.upper_status = false;
              obj.lower_status = true;
            } else if (item.restriction == 3 || item.restriction == 5) {
              obj.upper_status = true;
              obj.lower_status = false;
            } else if (item.restriction == 1) {
              obj.upper_status = true;
              obj.lower_status = true;
            } else if (item.restriction == '') {
              obj.upper_status = false;
              obj.lower_status = false;
            }

            arr.push(obj);
            _this6.addDataIndex += 1; // arr.push(item)
          }
        });
      } else if (this.data1.length == 0) {
        this.selectCopylist.forEach(function (item, index) {
          var obj = {
            key: 'A1_' + _this6.addDataIndex,
            factorId: item.factorId,
            restriction: item.restriction,
            lower: item.lower,
            upper: item.upper,
            sort: item.sort,
            editable: true
          };

          if (item.restriction == 2 || item.restriction == 4) {
            obj.upper_status = false;
            obj.lower_status = true;
          } else if (item.restriction == 3 || item.restriction == 5) {
            obj.upper_status = true;
            obj.lower_status = false;
          } else if (item.restriction == 1) {
            obj.upper_status = true;
            obj.lower_status = true;
          } else if (item.restriction == '') {
            obj.upper_status = false;
            obj.lower_status = false;
          }

          arr.push(obj);
          _this6.addDataIndex += 1;
        });
      }

      if (arr.length > 0) {
        this.$message.success('粘贴成功');
      } else {
        this.$message.warn('您复制的因子已存在');
      }

      this.data1 = [].concat(_toConsumableArray(this.data1), arr);
    },
    delTable: function delTable(key) {
      var newData = this.data1.filter(function (item) {
        return key != item.key;
      });
      this.data1 = newData;
      this.cacheData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },
    editTable: function editTable(key) {
      var newData = _toConsumableArray(this.data1);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        target.editable = true;
        this.data1 = newData;
      }
    },
    saveTable: function saveTable(key) {
      var newData = _toConsumableArray(this.data1);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        delete target.editable;
        this.data1 = newData;
        this.cacheData = newData.map(function (item) {
          return _objectSpread({}, item);
        });
      }
    },
    cancelTable: function cancelTable(key) {
      var newData = _toConsumableArray(this.data1);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        Object.assign(target, this.cacheData.filter(function (item) {
          return key === item.key;
        })[0]);
        delete target.editable;
        this.data1 = newData;
      }
    }
  }
};